import ExternalLinksBaseHandler from '../external_links_base_handler';

/**
 *
 */
class ExternalLinksCashiertHandler extends ExternalLinksBaseHandler {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinksCashiertHandler';
    static HandlerName = 'cashier';

	/**
     * Overrides base class checkPostMessageData
	 * Skips the postMessageData test since it wasn't required ( always returns true
	 * @param postMessageData
	 */
	checkPostMessageData(postMessageData) {
        return true;
    }


    /**
     * Overrides base class
     * @param postMessageData
     */
	executePostMessageAction(postMessageData) {
        if (postMessageData && postMessageData.state === 'backtogame') {
            this.close();
        } else {
            this.logger.warn('Invalid cashier post event message. PostData is null or contains not supported state');
        }
    }


    getHandlerName() {
        return ExternalLinksCashiertHandler.HandlerName;
    }

}

export default ExternalLinksCashiertHandler;